export enum LANGUAGES {
  FR = "fr",
  /* EN = "en", */
}
export const SUPPORTED_LANGUAGE = Object.values(LANGUAGES);
export const DEFAULT_LANGUAGE = LANGUAGES.FR;
